import { Button, ButtonProps } from '@mui/material';
import React, { useState } from 'react';
import useIsMountedRef from 'apps/frontend/hooks/useIsMountedRef';

export interface AsyncButtonProps extends Omit<ButtonProps, 'onClick'> {
  onClickAsync: (event) => Promise<void>;
  onAsyncActionComplete?: () => void;
}

export const AsyncButton: React.FC<AsyncButtonProps> = (props) => {
  const { onClickAsync, onAsyncActionComplete, ...rest } = props;
  const isMountedRef = useIsMountedRef();
  const [loading, setLoading] = useState(false);

  const handleClick = async (event) => {
    try {
      setLoading(true);
      await onClickAsync(event);
    } finally {
      if (isMountedRef.current) setLoading(false);
    }
    if (onAsyncActionComplete) onAsyncActionComplete();
  };

  return (
    <Button
      {...rest}
      onClick={handleClick}
      disabled={loading || rest.disabled}
    ></Button>
  );
};
